






























import { Component, Prop, Vue } from 'vue-property-decorator';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import {
  CustomSelectGroup,
  CustomSelectModel,
  CustomSelectOption
} from '@/components/CustomSelect/CustomSelectModel';
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue';

@Component({
  components: { Typography, CustomSelect }
})
export default class DropDownLocations extends Vue {
  @Prop({ default: true }) multiSelect?: boolean;
  @Prop({ default: false }) addAllLocationsOption?: boolean;
  @Prop({ default: '' }) allLocationsTextOption?: string;
  @Prop({ default: false }) showGroupName?: boolean;
  searchByLocation = '';
  customSelectLabel = '';

  selectedLocations: CustomSelectOption[] = [];

  dataTippy = `location-filter-${Math.floor(Math.random() * 10000)}`;

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'];
  }

  get disabledLocationFilter() {
    return (
      this.businessInfo.businessLocations &&
      this.businessInfo.businessLocations.length === 1
    );
  }

  get showLocationFilters() {
    return (
      this.businessInfo.businessLocations &&
      this.businessInfo.businessLocations.length > 0
    );
  }

  get filterLocations() {
    if (!this.businessInfo.businessLocations) return false;

    const group = this.businessInfo.businessLocations
      .map(
        (location: any, index: number) =>
          new CustomSelectOption(
            location.id || index.toString(),
            location.address,
            this.multiSelect
          )
      )
      .filter((item: CustomSelectOption) =>
        this.searchByLocation
          ? item.label
              .toLowerCase()
              .includes(this.searchByLocation.toLowerCase())
          : true
      );

    if (this.addAllLocationsOption) {
      group.unshift({
        label:
          this.allLocationsTextOption ||
          String(this.$t('common.components.dropDownLocations.allLocations')),
        isSelected: true
      });
    }

    const actionGroup = new CustomSelectGroup(
      group,
      this.showGroupName
        ? String(this.$t('common.components.dropDownLocations.locations'))
        : ''
    );

    return new CustomSelectModel(
      [actionGroup],
      String(this.$t('common.components.dropDownLocations.allLocations')),
      true,
      true,
      this.multiSelect,
      true
    );
  }

  changedLocation(items: CustomSelectOption[]) {
    this.selectedLocations = items;

    this.$emit('changedLocation', items);

    if (
      this.filterLocations &&
      this.filterLocations.groups[0].options.length === items.length &&
      this.filterLocations.groups[0].options.length > 1
    ) {
      this.customSelectLabel = String(
        this.$t('common.components.dropDownLocations.allLocations')
      );
    } else {
      this.customSelectLabel = '';
    }
  }

  searchLocationChange(text: string) {
    this.searchByLocation = text;
  }

  created() {
    if (this.filterLocations && !this.addAllLocationsOption)
      this.changedLocation(this.filterLocations.groups[0].options);
  }
}
